import { render, staticRenderFns } from "./seoMixin.vue?vue&type=template&id=76215d7f&"
import script from "./seoMixin.vue?vue&type=script&lang=js&"
export * from "./seoMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports